(function () {
  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function bindAddToCart(root) {
    root.querySelectorAll('[data-commerce-add]').forEach(function (form) {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        var original = button ? button.innerHTML : '';
        if (button) {
          button.disabled = true;
          button.innerHTML = '<span>Adicionando…</span>';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Não foi possível adicionar');
            return response.json();
          })
          .then(function () {
            updateCartCount();
            var toast = document.querySelector('[data-cart-toast]');
            if (toast) {
              toast.hidden = false;
              window.clearTimeout(window.mbCartToastTimer);
              window.mbCartToastTimer = window.setTimeout(function () { toast.hidden = true; }, 2600);
            }
            if (button) button.innerHTML = '<span>Adicionado ✓</span>';
            window.setTimeout(function () {
              if (button) {
                button.disabled = false;
                button.innerHTML = original;
              }
            }, 1600);
          })
          .catch(function () {
            form.submit();
          });
      });
    });
  }

  function initCarousel(carousel) {
    if (carousel.dataset.carouselReady === 'true') return;
    carousel.dataset.carouselReady = 'true';

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-slide]'));
    var dotsWrap = carousel.querySelector('[data-carousel-dots]');
    var track = carousel.querySelector('[data-carousel-track]');
    var previous = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    var current = 0;
    var timer;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartedAt = 0;
    var suppressClick = false;
    if (slides.length < 2) return;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      if (dotsWrap) {
        dotsWrap.querySelectorAll('button').forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === current);
          dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
        });
      }
    }

    function restart() {
      window.clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(function () { show(current + 1); }, 6500);
      }
    }

    if (dotsWrap) {
      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Ver campanha ' + (index + 1));
        dot.addEventListener('click', function () { show(index); restart(); });
        dotsWrap.appendChild(dot);
      });
    }
    if (previous) previous.addEventListener('click', function () { show(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(current + 1); restart(); });

    if (track) {
      track.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchStartedAt = Date.now();
        suppressClick = false;
        window.clearInterval(timer);
      }, { passive: true });

      track.addEventListener('touchend', function (event) {
        if (!event.changedTouches || event.changedTouches.length !== 1) {
          restart();
          return;
        }

        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        var elapsed = Date.now() - touchStartedAt;
        var threshold = Math.max(42, Math.min(track.clientWidth * 0.12, 78));
        var horizontalGesture = Math.abs(deltaX) > threshold && Math.abs(deltaX) > Math.abs(deltaY) * 1.25;

        if (horizontalGesture && elapsed < 900) {
          suppressClick = true;
          show(deltaX < 0 ? current + 1 : current - 1);
          window.setTimeout(function () { suppressClick = false; }, 350);
        }
        restart();
      }, { passive: true });

      track.addEventListener('touchcancel', restart, { passive: true });
      track.addEventListener('click', function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    carousel.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    carousel.addEventListener('mouseleave', restart);
    show(0);
    restart();
  }

  function initVideos(root) {
    var modal = root.querySelector('[data-video-modal]');
    if (!modal) return;
    var player = modal.querySelector('[data-video-player]');
    var lastTrigger;

    function close() {
      if (player) {
        player.pause();
        player.removeAttribute('src');
        player.load();
      }
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    root.querySelectorAll('[data-video-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        lastTrigger = trigger;
        if (player) {
          player.src = trigger.dataset.videoOpen;
          player.load();
        }
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var closeButton = modal.querySelector('.mb-video-modal__close');
        if (closeButton) closeButton.focus();
      });
    });
    modal.querySelectorAll('[data-video-close]').forEach(function (button) { button.addEventListener('click', close); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  function init(root) {
    bindAddToCart(root);
    root.querySelectorAll('[data-commerce-carousel]').forEach(initCarousel);
    initVideos(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-commerce-root]').forEach(init);
  });
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-commerce-root]').forEach(init);
  });
})();
